const sizes = {
    phone: '37.5em',
    tabport: '56.25em',
    tabland: '75em',
    bigdesktop: '112.5em',
  };

export const devices = {
    phone: `(max-width: ${sizes.phone})`,
    tabport:  `(max-width: ${sizes.tabport})`,
    tabland: `(max-width: ${sizes.tabland})`,
    bigdesktop: `(max-width: ${sizes.bigdesktop})`
}